const pending = new Set<string>();

export const markBranchAwaitingAiName = (branchId: string) => {
  pending.add(branchId);
};

export const isBranchAwaitingAiName = (branchId: string) =>
  pending.has(branchId);

export const clearBranchAwaitingAiName = (branchId: string) => {
  pending.delete(branchId);
};
